// The same notice is public to every visitor; no sign-in or migration flag is needed.
import { requestV2 } from './v2-only.ts'

/** The site's notice, `{ notice }`, or null when none is set. */
export const siteNotice = () =>
  requestV2(
    () => import('./v2.ts'),
    async ({ answer, v2SignedOut }) => {
      const { data, error, response } = await v2SignedOut().GET('/v2/notice')
      return answer(response.status, data ?? error ?? {})
    },
  )
